/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    arrayOf, object, func, bool, shape, string, number,
} from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Close from '@material-ui/icons/Close';
import loadable from '@loadable/component';
import SlideNavMenuItem from './Items/SlideNavMenuItem';
import CountryFinderMobile from '../../../../../ContentTypeComponents/CountryFinder/CountryFinderMobile';
import LoginDropdown from './Items/LoginDropdown';
import PreferenceDropdown from './PreferenceDropdown';
import { getCountryName, getCurrencyName, getLanguageName } from '../../../../../../../state/ducks/Member/ducks/Auth/helper/helper';
import { getDataDictionary } from '../../../../../../../state/ducks/App/App-Selectors';
import { getFeatureFlags } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const CountryDeliveryDropdown = loadable(() => import(/* webpackChunkName: "CountryDeliveryDropdown" */ '../../../../../ContentTypeComponents/CountryFinder/CountryDeliveryDropdown'));

const styles = (theme) => {
    return {
        navMenuRender: {
            width: '100%',
            backgroundColor: theme.palette.colorPrimaryContrast,
        },
        navMenu: {
            margin: '0',
            listStyle: 'none',
            padding: '0',
            overflow: 'hidden',
        },
        slideSetUp: {
            display: 'flex',
            width: '1000px',
            transition: 'transform 0.3s ease-in',
        },
        toSlide: {
            transform: 'translateX(-300px)',
        },
        toSlideThird: {
            transform: 'translateX(-600px)',
        },
        titleBar: {
            fontSize: '15px',
            fontWeight: 'bold',
            display: 'block',
            fontFamily: theme.typography.fontFamily,
            outline: 'none',
            padding: '20px 10px',
            '&:focus': {
                outline: 'none',
            },
            borderBottom: `0.5px solid ${theme.palette.colorNeutral30}`,
        },
        slideTitle: {
            animation: 'slideIn 0.80s ease',
        },
        '@keyframes slideIn': {
            from: { marginLeft: '100%' },
            to: { marginLeft: '0' },
        },
        shadow: {
            marginTop: '2px',
            webkitBoxShadow: '0px -4px 3px rgba(100, 100, 100, 0.21)',
            mozBoxShadow: '0px -4px 3px rgba(100, 100, 100, 0.21)',
            boxShadow: '0px -4px 3px rgba(100, 100, 100, 0.21)',
        },
        leftArrow: {
            height: '20px',
            width: '25px',
            pointerEvent: 'none',
            float: 'left',
            paddingRight: '5px',
        },
        title: {
            padding: '15px 20px',
            fontSize: '14px',
            fontWeight: '600',
            color: theme.palette.colorPrimary,
        },
        BackCloseContainer: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        CloseIcon: {
            marginTop: '-8px',
            fontSize: '22px',
        },
        slideTopContainer: {
            display: 'none',
        },
        topContainer: {
            display: 'block',
        },
        LogoMobile: {
            maxHeight: '45px',
            maxWidth: '113px',
            margin: '0 20px',
        },
        LogoCloseContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 0',
        },
        CloseIconLevel1: {
            marginTop: '8px',
            fontSize: '22px',
        },
        LinksContainer: {
            paddingBottom: '20px',
            borderBottom: `1px solid ${theme.palette.colorNeutral30}`,
        },
        menuLinkItemContainer: {
            paddingTop: '20px',
        },
        PreferencesContainer: {
            paddingTop: '20px',
            '&>div:nth-child(1)': {
                fontSize: '14px',
                fontWeight: '600',
                color: theme.palette.colorPrimary,
                padding: '0 0 10px 20px',
            },
        },
        NavigationMenuContainer: {
            paddingTop: '20px',
        },
        onlyLabel: {
            width: '300px',
            maxWidth: '300px',
            fontSize: '14px',
            outline: 'none',
            padding: '5px 19px',
            color: theme.palette.preferenceOption?.color,
        },
    };
};
const initialState = {
    transformed: false,
    title: '',
    collections: [],
    thirdLevelTitle: '',
    transformedLevelThird: false,
    collectionsCopyLevelThird: [],
    isTopNav: false,
};

const BotMenu = ({ menu, brand }) => (
    <div>
        <SlideNavMenuItem
            key={menu.label}
            itemType=""
            itemLabel={menu.label}
            itemLink={menu.link}
            icon={menu.icon}
            hasSubmenu={false}
            linkStyle={menu.linkStyle}
            brand={brand}
        />
        <div>
            {// Second Level
                menu.submenu
        && menu.submenu.map((subMenu) => {
            return (
                <div>
                    <SlideNavMenuItem
                        key={subMenu.label}
                        itemType=""
                        itemLabel={subMenu.label}
                        itemLink={subMenu.link}
                        icon={subMenu.icon}
                        hasSubmenu={false}
                        linkStyle={subMenu.linkStyle}
                        brand={brand}
                    />
                    <div>
                        {// Third Level
                            subMenu.submenu
                  && subMenu.submenu.map((subSubMenu) => {
                      return (
                          <SlideNavMenuItem
                              key={subSubMenu.label}
                              itemType=""
                              itemLabel={subSubMenu.label}
                              itemLink={subSubMenu.link}
                              icon={subSubMenu.icon}
                              hasSubmenu={false}
                              linkStyle={subSubMenu.linkStyle}
                              brand={brand}
                          />
                      );
                  })
                        }
                    </div>
                </div>
            );
        })
            }
        </div>
    </div>
);
BotMenu.propTypes = {
    menu: object.isRequired,
    brand: object.isRequired,
};

class SlideNavMenu extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            transformed: false,
            title: '',
            isTopNav: false,
            thirdLevelTitle: '',
            collections: [],
            transformedLevelThird: false,
            collectionsCopyLevelThird: [],
            country: {
                name: '',
                icon: '',
            },
            language: '',
            currency: '',
        };
    }

    componentDidMount() {
        this.setMenuCountry();
        this.setCurrentLanguage();
        this.setCurrentCurrency();
    }

    setMenuCountry = () => {
        const { countriesContent: { country_group } } = this.props;
        const countrySessionStorage = getCountryName();
        let countryName = '';
        let countryIcon = '';
        if (countrySessionStorage && Array.isArray(country_group) && country_group.length) {
            const countryItem = country_group.find((item) => item.country?.href === countrySessionStorage);
            if (countryItem) {
                countryName = countryItem.country?.title;
                countryIcon = countryItem.country_flag_image?.url;
            }
        }

        this.setState({ country: { name: countryName, icon: countryIcon } });
    }

    setCurrentCurrency = () => {
        const { currenciesList, featureFlags } = this.props;
        const currencySessionStorage = getCurrencyName();
        let currentCurrency = '';
        if (featureFlags['is-only-cad-currency-allowed']) {
            currentCurrency = 'CAD C$';
        } else if (featureFlags['is-only-usd-currency-allowed']) {
            currentCurrency = 'USD $';
        } else if (currencySessionStorage && Array.isArray(currenciesList) && currenciesList.length) {
            const currencyItem = currenciesList.find((item) => item.currency_value === currencySessionStorage);
            if (currencyItem) {
                currentCurrency = `${currencyItem.currency_value} ${currencyItem.currency_symbol}`;
            }
        }

        this.setState({ currency: currentCurrency });
    }

    setCurrentLanguage = () => {
        const { languagesList, featureFlags } = this.props;
        const languageSessionStorage = getLanguageName();
        let currentLanguage = '';
        if (featureFlags['is-only-language-English-allowed']) {
            currentLanguage = 'English';
        } else if (featureFlags['is-only-language-French-allowed']) {
            currentLanguage = 'Français';
        } else if (languageSessionStorage && Array.isArray(languagesList) && languagesList.length) {
            const languageItem = languagesList.find((item) => item.link?.href === languageSessionStorage);
            if (languageItem) {
                currentLanguage = languageItem.link?.title;
            }
        }

        this.setState({ language: currentLanguage });
    }

  showTitle = (title, id, navTitle) => () => {
      const collectionsCopy = [];
      id.map((collection) => collectionsCopy.push(collection));
      this.setState({
          title,
          collections: collectionsCopy,
          isTopNav: navTitle?.length > 0,
      });
  };

  showTitleLevelThird = (thirdLevelTitle, id) => () => {
      const collectionsCopyLevelThird = [];
      id.map((collection) => collectionsCopyLevelThird.push(collection));
      this.setState({
          thirdLevelTitle,
          collectionsCopyLevelThird,
      });
  };

  showThirdMenu = (linkStyle) => {
      if (linkStyle !== 'Currency') {
          this.setState({
              transformedLevelThird: true,
              transformed: false,
          });
      }
  };

  showSecondMenu = () => {
      this.setState({
          transformed: true,
          transformedLevelThird: false,
      });
  };

  showFirstMenu = () => {
      this.setMenuCountry();
      this.setCurrentLanguage();
      this.setCurrentCurrency();
      this.setState({
          transformed: false,
          transformedLevelThird: false,
      });
      this.setState(initialState);
  };

  renderLogo = (logo, classes) => {
      if (logo) {
          const icon = logo.image?.url;
          const title = logo.link?.title || 'logo_mobile';

          if (icon) {
              return (
                  <img id="logo-mobile" className={classes.LogoMobile} src={icon} alt={title} />
              );
          }
      }
      return null;
  }

  navMenuRender = (navMenuList, handleClose, classes, brand, logo, languageChange, countriesContent) => {
      /* eslint arrow-body-style: "off" */
      const menuList = navMenuList.slice(navMenuList[0].label === '[SEARCH]', navMenuList.length);
      const selectedCountry = getCountryName();
      const selectedLanguage = getLanguageName();
      const itemsWithSubmenu = menuList.filter((menu) => menu.submenu !== undefined && menu.submenu !== null && menu.type !== 'Navigation Menu');
      const navItemsWithSubmenu = menuList.filter((menu) => menu.submenu !== undefined && menu.submenu !== null && menu.type === 'Navigation Menu' && menu.url === selectedCountry);
      const itemsWithoutSubmenu = menuList.filter((menu) => menu.submenu === undefined || menu.submenu === null);
      const { isBot, dataDictionary, featureFlags } = this.props;
      const {
          title,
          collections,
          transformed,
          transformedLevelThird,
          collectionsCopyLevelThird,
          thirdLevelTitle,
          country,
          language,
          currency,
          isTopNav,
      } = this.state;

      return (
          <>
              <LoginDropdown handleClose={handleClose} />
              <div
                  className={classes.navMenuRender}
                  style={{
                      overflow: 'hidden',
                      width: '300px',
                  }}
              >
                  <div className={
                      transformed
                          ? `${classes.slideTopContainer}`
                          : `${classes.topContainer}`
                  }
                  >
                      <div className={classes.LogoCloseContainer}>
                          {this.renderLogo(logo, classes)}
                          <Button
                              aria-label="Close Menu"
                              onClick={handleClose}
                              data-test="nav-menu-close-button"
                          >
                              <Close className={classes.CloseIconLevel1} />
                          </Button>
                      </div>
                      {(brand?.code === '08F' && countriesContent) && <CountryFinderMobile handleClose={handleClose} data={countriesContent} />}
                  </div>
                  <div
                      className={
                      // eslint-disable-next-line no-nested-ternary
                          transformed
                              ? `${classes.slideSetUp} ${classes.toSlide}`
                              : transformedLevelThird
                                  ? `${classes.slideSetUp} ${classes.toSlideThird}`
                                  : `${classes.slideSetUp}`
                      }
                  >
                      <div>
                          {(navItemsWithSubmenu.length > 0)
                            && (
                                <div className={classes.NavigationMenuContainer} role="menu">
                                    {navItemsWithSubmenu.map((menu, indexMenu) => {
                                        const hasSubmenu = menu.submenu !== undefined && menu.submenu !== null;
                                        const keyItem = `menuItem_${menu.level}_${indexMenu}`;
                                        // Bot Traffic (isBot) - Pre-Render Menu
                                        if (isBot) {
                                            return <BotMenu menu={menu} brand={brand} />;
                                        }
                                        // Standard
                                        return (
                                            <div
                                                role="menuitem"
                                                onClick={this.showSecondMenu}
                                                tabIndex="0"
                                                onKeyDown={this.showSecondMenu}
                                                style={{ width: '300px', outline: 'none' }}
                                                key={menu.label}
                                            >
                                                <div className={classes.navMenu}>
                                                    <SlideNavMenuItem
                                                        key={keyItem}
                                                        itemType="TopNav"
                                                        itemLabel={menu.label}
                                                        itemLink={menu.link}
                                                        hasSubmenu={hasSubmenu}
                                                        handleClose={handleClose}
                                                        linkStyle={menu.linkStyle}
                                                        tabIndex="0"
                                                        brand={brand}
                                                        handleClick={() => this.showTitle(menu.label, menu.submenu, 'TopNav')}
                                                        currentCountryData={country}
                                                        language={language}
                                                        currency={currency}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                          <div className={classes.LinksContainer}>
                              {itemsWithoutSubmenu.map((menu) => {
                                  // Bot Traffic (isBot) - Pre-Render Menu
                                  if (isBot) {
                                      return <BotMenu menu={menu} brand={brand} />;
                                  }

                                  // Standard
                                  if (menu?.main_link) {
                                      return (
                                          <div
                                              role="menuitem"
                                              onClick={this.showSecondMenu}
                                              tabIndex="0"
                                              onKeyDown={this.showSecondMenu}
                                              style={{ width: '300px', outline: 'none' }}
                                              key={menu.label}
                                          >
                                              <div className={menu.link ? classes.navMenu : classes.navMenu}>
                                                  <SlideNavMenuItem
                                                      key={menu.label}
                                                      itemType=""
                                                      itemLabel={menu.label}
                                                      itemLink={menu.link}
                                                      icon={menu.icon}
                                                      hasSubmenu={false}
                                                      handleClose={handleClose}
                                                      linkStyle={menu.linkStyle}
                                                      brand={brand}
                                                      category={menu.category}
                                                  />
                                              </div>
                                          </div>
                                      );
                                  }

                                  return null;
                              })}
                          </div>

                          <div className={`${classes.LinksContainer} ${classes.menuLinkItemContainer}`}>
                              {itemsWithoutSubmenu.map((menu) => {
                                  if (!menu?.main_link) {
                                      return (
                                          <div
                                              role="menuitem"
                                              onClick={this.showSecondMenu}
                                              tabIndex="0"
                                              onKeyDown={this.showSecondMenu}
                                              style={{ width: '300px', outline: 'none' }}
                                              key={menu.label}
                                          >
                                              <div className={menu.link ? classes.navMenu : classes.navMenu}>
                                                  <SlideNavMenuItem
                                                      key={menu.label}
                                                      itemType=""
                                                      itemLabel={menu.label}
                                                      itemLink={menu.link}
                                                      icon={menu.icon}
                                                      hasSubmenu={false}
                                                      handleClose={handleClose}
                                                      linkStyle={menu.linkStyle}
                                                      brand={brand}
                                                      category={menu.category}
                                                  />
                                              </div>
                                          </div>
                                      );
                                  }

                                  return null;
                              })}
                          </div>
                          <div>{(!window.location.pathname.includes('checkout'))
                             && (
                                 <div className={classes.PreferencesContainer}>
                                     {getLanguageName() === '/en' ? <div>PREFERENCES</div> : <div>{dataDictionary?.PREFERENCES || 'PREFERENCES'}</div>}
                                     {itemsWithSubmenu.map((menu, indexMenu) => {
                                         const hasSubmenu = menu.submenu !== undefined && menu.submenu !== null;
                                         const keyItem = `menuItem_${menu.level}_${indexMenu}`;
                                         // Bot Traffic (isBot) - Pre-Render Menu
                                         if (isBot) {
                                             return <BotMenu menu={menu} brand={brand} />;
                                         }
                                         if (window.location.pathname.includes('checkout') && menu.label === 'Currency') {
                                             return null;
                                         }
                                         // language changed based on feature flags
                                         if ((featureFlags['is-only-language-English-allowed'] || featureFlags['is-only-language-French-allowed']) && (menu.label === 'Language' || menu.label === 'Langue')) {
                                             return (
                                                 <div className={classes.onlyLabel}>
                                                     <SlideNavMenuItem
                                                         key={keyItem}
                                                         itemType=""
                                                         itemLabel={menu.label}
                                                         itemLink={menu.link}
                                                         hasSubmenu={false}
                                                         handleClose={handleClose}
                                                         linkStyle={menu.linkStyle}
                                                         tabIndex="0"
                                                         brand={brand}
                                                         handleClick={() => this.showTitle(menu.label, menu.submenu, '')}
                                                         currentCountryData={country}
                                                         language={language}
                                                         currency={currency}
                                                         languageLabel
                                                         onlyLabel
                                                     />
                                                 </div>
                                             );
                                         }
                                         // feature flags
                                         if ((featureFlags['is-only-cad-currency-allowed'] || featureFlags['is-only-usd-currency-allowed']) && menu.label === 'Currency') {
                                             return (
                                                 <div className={classes.onlyLabel}>
                                                     <SlideNavMenuItem
                                                         key={keyItem}
                                                         itemType=""
                                                         itemLabel={menu.label}
                                                         itemLink={menu.link}
                                                         hasSubmenu={false}
                                                         handleClose={handleClose}
                                                         linkStyle={menu.linkStyle}
                                                         tabIndex="0"
                                                         brand={brand}
                                                         handleClick={() => this.showTitle(menu.label, menu.submenu, '')}
                                                         currentCountryData={country}
                                                         language={language}
                                                         currency={currency}
                                                         onlyLabel
                                                     />
                                                 </div>
                                             );
                                         }
                                         // Standard
                                         return (
                                             <div
                                                 role="menuitem"
                                                 onClick={this.showSecondMenu}
                                                 tabIndex="0"
                                                 onKeyDown={this.showSecondMenu}
                                                 style={{ width: '300px', outline: 'none' }}
                                                 key={menu.label}
                                             >
                                                 <div className={classes.navMenu}>
                                                     <SlideNavMenuItem
                                                         key={keyItem}
                                                         itemType=""
                                                         itemLabel={menu.label}
                                                         itemLink={menu.link}
                                                         hasSubmenu={hasSubmenu}
                                                         handleClose={handleClose}
                                                         linkStyle={menu.linkStyle}
                                                         tabIndex="0"
                                                         brand={brand}
                                                         handleClick={() => this.showTitle(menu.label, menu.submenu, '')}
                                                         currentCountryData={country}
                                                         language={language}
                                                         currency={currency}
                                                     />
                                                 </div>
                                             </div>
                                         );
                                     })}
                                 </div>
                             )}
                          </div>
                      </div>
                      <div className={`${classes.navMenu} ${classes.listitem}`} style={{ minHeight: '100vh' }}>
                          <div
                              onClick={this.showFirstMenu}
                              tabIndex="0"
                              role="button"
                              onKeyDown={this.showFirstMenu}
                              style={{ width: '300px', outline: 'none' }}
                          >
                              <span
                                  className={`${classes.titleBar} ${classes.shadow}`}
                                  style={{ overflow: 'auto' }}
                              >
                                  <svg
                                      viewBox="0 0 24 24"
                                      fill="#1f1f1b"
                                      preserveAspectRatio="xMidYMid meet"
                                      focusable="false"
                                      className={classes.leftArrow}
                                  >
                                      <g>
                                          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                      </g>
                                  </svg>
                                  <div className={classes.BackCloseContainer}>{selectedLanguage === '/en' ? 'Back to Main' : dataDictionary?.['Back to Main'] || 'Back to Main'}
                                      <Button
                                          aria-label="Close Menu"
                                          onClick={handleClose}
                                          data-test="nav-menu-close-button"
                                      >
                                          <Close className={classes.CloseIcon} />
                                      </Button>
                                  </div>
                              </span>
                          </div>
                          { title ? <div className={classes.title}>{selectedLanguage === '/en' ? title.toUpperCase() : dataDictionary?.[title]?.toUpperCase() || title.toUpperCase()}</div> : null }
                          <div>
                              {!isTopNav && (title.toLowerCase().includes('country') && countriesContent ? <CountryDeliveryDropdown data={collections} handleClose={handleClose} /> : <PreferenceDropdown menu={collections} title={title.toLowerCase()} handleClose={handleClose} languageChange={languageChange} />)}
                              {isTopNav && (
                                  <div>
                                      {collections.map((submenu, submenuindexMenu) => {
                                          const hasSubmenu = submenu.submenu !== undefined && submenu.submenu !== null;
                                          const keyItem = `menuItem_${submenu.level}_${submenuindexMenu}`;
                                          return (
                                              <div
                                                  role="menuitem"
                                                  onClick={this.showThirdMenu}
                                                  tabIndex="0"
                                                  onKeyDown={this.showThirdMenu}
                                                  style={{ width: '300px', outline: 'none' }}
                                                  key={submenu.label}
                                              >
                                                  <div className={classes.navMenu}>
                                                      {hasSubmenu && collections.length > 0 ? (
                                                          <SlideNavMenuItem
                                                              key={keyItem}
                                                              itemLabel={submenu.label}
                                                              itemLink={submenu.link}
                                                              hasSubmenu={hasSubmenu}
                                                              handleClose={handleClose}
                                                              linkStyle={submenu.linkStyle}
                                                              tabIndex="0"
                                                              brand={brand}
                                                              category={submenu.name}
                                                              handleClick={() => this.showTitleLevelThird(submenu.label, submenu.submenu)}
                                                          />
                                                      ) : (
                                                          <SlideNavMenuItem
                                                              key={submenu.label}
                                                              itemLabel={submenu.label}
                                                              itemLink={submenu.link}
                                                              icon={submenu.icon}
                                                              hasSubmenu={false}
                                                              handleClose={handleClose}
                                                              linkStyle={submenu.linkStyle}
                                                              brand={brand}
                                                              category={submenu.name}
                                                              eventCategory={submenu.trackingCategory}
                                                              eventAction={submenu.trackingAction}
                                                              eventLabel={submenu.trackingLabel}
                                                          />
                                                      )}
                                                  </div>
                                              </div>
                                          );
                                      })}
                                  </div>
                              )}
                          </div>
                      </div>
                      <div className={`${classes.navMenu} ${classes.listitem}`} style={{ minHeight: '100vh' }}>
                          <div
                              onClick={this.showSecondMenu}
                              tabIndex="0"
                              role="button"
                              onKeyDown={this.showSecondMenu}
                              style={{ width: '300px', outline: 'none' }}
                          >
                              <span
                                  className={`${classes.titleBar} ${classes.shadow}`}
                                  style={{ overflow: 'auto' }}
                              >
                                  <svg
                                      viewBox="0 0 24 24"
                                      fill="#1f1f1b"
                                      preserveAspectRatio="xMidYMid meet"
                                      focusable="false"
                                      className={classes.leftArrow}
                                  >
                                      <g>
                                          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                      </g>
                                  </svg>
                                  <div>Back to Main</div>
                              </span>
                          </div>
                          <div className={classes.title}>{thirdLevelTitle}</div>
                          {collectionsCopyLevelThird.map((submenu) => {
                              return (
                                  <SlideNavMenuItem
                                      key={submenu.label}
                                      itemType=""
                                      itemLabel={submenu.label}
                                      itemLink={submenu.link}
                                      hasSubmenu={false}
                                      handleClose={handleClose}
                                      linkStyle={submenu.linkStyle}
                                      tabIndex="0"
                                  />
                              );
                          })}
                      </div>
                  </div>
              </div>
          </>
      );
  };

  render() {
      const {
          navMenuList, classes, handleClose, brand, logo, languageChange, countriesContent,
      } = this.props;
      return this.navMenuRender(navMenuList, handleClose, classes, brand, logo, languageChange, countriesContent);
  }
}

const mapStateToProps = (state) => ({
    dataDictionary: getDataDictionary(state),
    featureFlags: getFeatureFlags(state),
});

SlideNavMenu.propTypes = {
    isBot: bool,
    navMenuList: arrayOf(shape({
        icon: string,
        label: string,
        level: number,
        link: string,
        linkStyle: string,
        parentPosition: number,
    })).isRequired,
    classes: object.isRequired,
    handleClose: func.isRequired,
    brand: shape({
        domain: string.isRequired,
    }),
    logo: shape({
        image: shape({
            content_type: string.isRequired,
            description: string.isRequired,
            file_size: string.isRequired,
            filename: string.isRequired,
            title: string.isRequired,
            url: string.isRequired,
        }),
        link: shape({
            title: string,
            href: string,
        }),
    }),
    languagesList: arrayOf(shape({
        link: shape({
            title: string.isRequired,
            href: string.isRequired,
        }).isRequired,
    })).isRequired,
    currenciesList: arrayOf(shape({
        currency_name: string.isRequired,
        currency_symbol: string.isRequired,
        currency_value: string.isRequired,
    })).isRequired,
    languageChange: func.isRequired,
    countriesContent: shape({
        placeholder: string.isRequired,
        country_group: arrayOf(shape({
            country: shape({
                title: string,
                href: string,
            }),
            country_flag_image: shape({
                url: string,
            }),
        })).isRequired,
        text_color: string.isRequired,
    }).isRequired,
    dataDictionary: object.isRequired,
    featureFlags: shape({
        'is-only-language-English-allowed': bool,
        'is-only-language-French-allowed': bool,
        'is-only-cad-currency-allowed': bool,
        'is-only-usd-currency-allowed': bool,
    }).isRequired,
};
SlideNavMenu.defaultProps = {
    brand: {},
    isBot: true,
    logo: null,
};

export default connect(mapStateToProps)(withStyles(styles)(SlideNavMenu));
